module.exports = __webpack_public_path__ + "img/4 - 2 - 3 - 1.5b072ac9.jpg";